export const AVATAR_PALETTE: Array<{ bg: string; fg: string }> = [
  { bg: 'bg-blue-500', fg: 'text-white' },
  { bg: 'bg-violet-500', fg: 'text-white' },
  { bg: 'bg-rose-500', fg: 'text-white' },
  { bg: 'bg-amber-500', fg: 'text-white' },
  { bg: 'bg-emerald-500', fg: 'text-white' },
  { bg: 'bg-cyan-600', fg: 'text-white' },
  { bg: 'bg-pink-500', fg: 'text-white' },
  { bg: 'bg-indigo-500', fg: 'text-white' },
  { bg: 'bg-teal-500', fg: 'text-white' },
  { bg: 'bg-orange-500', fg: 'text-white' },
];

export function getInitials(firstName: string, lastName: string): string {
  return `${firstName[0] ?? ''}${lastName[0] ?? ''}`.toUpperCase();
}

export function getCompanyInitials(name: string): string {
  return name.slice(0, 2).toUpperCase();
}

export function avatarColor(seed: string): { bg: string; fg: string } {
  let hash = 0;
  for (let i = 0; i < seed.length; i++)
    hash = seed.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_PALETTE[Math.abs(hash) % AVATAR_PALETTE.length]!;
}

/** Returns a combined Tailwind bg+text class string for an avatar, derived from a seed string */
export function avatarColorClass(seed: string): string {
  const { bg, fg } = avatarColor(seed);
  return `${bg} ${fg}`;
}

export function imgUrl(
  url: string | null | undefined,
  size: number,
): string | undefined {
  if (!url) return undefined;
  return `${url}?fit=crop&w=${size}&h=${size}&auto=format`;
}
